import React from 'react';
import Modal from 'react-bootstrap/Modal';

export default function ModalViewer(props) {
  return (
    <Modal {...props}>
      {props.children}
    </Modal>
  )
}